interface IconProps {
	active?: boolean;
	color?: string;
}

export const OverviewIcon = ({ active, color }: IconProps) => (
	<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect
			x="3.25"
			y="9.75"
			width="7.5"
			height="10.5"
			fill={active ? color : 'white'}
			stroke={active ? color : '#0F0F0F'}
			strokeWidth="1.5"
			strokeLinejoin="round"
		/>
		<rect
			x="13.25"
			y="4.75"
			width="7.5"
			height="15.5"
			fill={active ? color : 'white'}
			stroke={active ? color : '#0F0F0F'}
			strokeWidth="1.5"
			strokeLinejoin="round"
		/>
	</svg>
);
